// extracted by mini-css-extract-plugin
export default {"createGeofence":"geofences-page_createGeofence__Gw9HT","geofencesList":"geofences-page_geofencesList__2GCvc","geofenceItem":"geofences-page_geofenceItem__ZmY+V"};